import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'booking-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit {

  @Input() title: string;
  @Input() imgPath: string;

  constructor() { }

  ngOnInit(): void {
  }

}
